export const environment = {
  production: true,
  ApiUrl: 'https://hcrplapitest.clavisco.com/api/',
  ApiSiteUrl: 'https://hcrpltest.clavisco.com//#/',
  Theme: 'clvs',
  env: "Pruebas",
};
